import { IconType } from '../../../constants';
var extractJiraTaskIcon = function extractJiraTaskIcon(taskType) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Task';
  switch (taskType) {
    case 'JiraBug':
      return {
        icon: IconType.Bug,
        label: label
      };
    case 'JiraChange':
      return {
        icon: IconType.Change,
        label: label
      };
    case 'JiraEpic':
      return {
        icon: IconType.Epic,
        label: label
      };
    case 'JiraIncident':
      return {
        icon: IconType.Incident,
        label: label
      };
    case 'JiraProblem':
      return {
        icon: IconType.Problem,
        label: label
      };
    case 'JiraServiceRequest':
      return {
        icon: IconType.ServiceRequest,
        label: label
      };
    case 'JiraStory':
      return {
        icon: IconType.Story,
        label: label
      };
    case 'JiraSubTask':
      return {
        icon: IconType.SubTask,
        label: label
      };
    case 'JiraTask':
    default:
      return {
        icon: IconType.Task,
        label: label
      };
  }
};
export default extractJiraTaskIcon;